import { render, staticRenderFns } from "./announcementConfig.vue?vue&type=template&id=7803a772&scoped=true&"
import script from "./announcementConfig.vue?vue&type=script&lang=js&"
export * from "./announcementConfig.vue?vue&type=script&lang=js&"
import style0 from "./announcementConfig.vue?vue&type=style&index=0&id=7803a772&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7803a772",
  null
  
)

export default component.exports